import { Component } from '@angular/core';

@Component({
  selector: 'pdf-findbar-options-three-container',
  templateUrl: './pdf-findbar-options-three-container.component.html',
  styleUrls: ['./pdf-findbar-options-three-container.component.css'],
})
export class PdfFindbarOptionsThreeContainerComponent {}
